import React from "react";

const FIREAULDESCRIPTIONS = [
  <p>
    Led the development of a full-stack application to allow people to monitor
    and receive help during wildfires
  </p>,
  <p>
    Integrated an interactive Google map and Google Vision API image parsing for
    object classification
  </p>,
  <p>
    Deployed front-end using React and REST API with Flask on AWS EC2 instance
  </p>,
];

const AGGIESECTIONDESCRIPTIONS = [
  <p>
    Developed application to notify students when a course section is open using
    Python, Selenium, and Firebase
  </p>,
  <p>
    Used by 70+ students at its peak but had to cease operation after 16 hours
    due to conflict with university rules
  </p>,
];

export { FIREAULDESCRIPTIONS, AGGIESECTIONDESCRIPTIONS };
